import { UserType } from 'types/user';
import { CompanyType } from 'types/company';
import { TERMS_VERSION } from './constants';

export const getUserType = (isCompany: boolean) =>
  isCompany ? 'company' : 'candidate';

export const requiredDataCompleted = (user: UserType | null) =>
  user?.name && user?.surname && user?.cellPhone && user?.document;

export const requiredCompanyDataCompleted = (company: CompanyType | null) =>
  company?.document &&
  company?.fantasyName &&
  company?.industry &&
  company?.amountIntervalWorkers &&
  company?.state &&
  company?.city;

export const isUpdatedTerms = (userTerms?: string | null) =>
  userTerms === TERMS_VERSION;
